import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/backend";
import { extractionWrapper } from "@/lib/backend/utils/extract";
import { useMe } from "@/lib/hooks/use-me";

export function useApplications(projectId?: string) {
  const { me } = useMe();

  return useQuery({
    queryKey: ["applications", projectId, me?.employee?.id],
    queryFn: () =>
      extractionWrapper(
        api.application.getAll({
          filter: {
            "availabilitySlot.projectId": {
              value: projectId,
            },
            "employee.id": {
              value: me?.employee?.id,
              operator: "equals",
            },
          },
          include: {
            availabilitySlot: {
              select: true,
              project: {
                select: true,
              },
              userFunction: {
                select: true,
              },
            },
          },
          sort: {
            field: "availabilitySlot.startAt",
            order: "asc",
          },
        }),
      ),
    enabled: !!projectId && !!me?.employee?.id,
  });
}
